module.exports = __webpack_public_path__ + "static/media/nip-tag.f3194dfe.svg";